export const MUTATIONS = {
  app: {
    switchTheme: "switchTheme",
    showSnackbar: "showSnackbar",
  },
  auth: {
    // register
    updateFullNameRegister: "updateFullNameRegister",
    updateMobileRegister: "updateMobileRegister",
    updatePasswordRegister: "updatePasswordRegister",
    // login
    updateMobileLogin: "updateMobileLogin",
    updatePasswordLogin: "updatePasswordLogin",
  },
  panel: {
    setUser: "setUser",
    updateFullName: "updateFullName",
    updateAddress: "updateAddress",
    updateProvince: "updateProvince",
    updateCity: "updateCity",
    updateAvatar: "updateAvatar",
    removeAvatar: "removeAvatar",
    setProduct: "setProduct",
    resetProduct: "resetProduct",
    setInvoices: "setInvoices",
    setTransactions: "setTransactions",
    setCartItems: "setCartItems",
    addToCart: "addToCart",
    setProducts: "setProducts",
    updateCommentUsername: "updateCommentUsername",
    updateCommentMessage: "updateCommentMessage",
    resetComment: "resetComment",
  },
  admin: {
    // products
    setProduct: "setProduct",
    setProducts: "setProducts",
    editProduct: "editProduct",
    deleteProduct: "deleteProduct",
    updateProductName: "updateProductName",
    updateProductCategory: "updateProductCategory",
    updateProductAmount: "updateProductAmount",
    updateProductSpecialSell: "updateProductSpecialSell",
    updateProductInventory: "updateProductInventory",
    updateProductDescription: "updateProductDescription",
    updateProductSpecial: "updateProductSpecial",
    updateProductNew: "updateProductNew",
    updateProductImage: "updateProductImage",
    resetProductData: "resetProductData",
    // landing
    updateMainBannerAboutUs: "updateMainBannerAboutUs",
    updateAboutUsTitle: "updateAboutUsTitle",
    updateAboutUsLanguage: "updateAboutUsLanguage",
    updateAboutUsDescription: "updateAboutUsDescription",
    updateAluminiumLanguage: "updateAluminiumLanguage",
    updateAluminiumTitle: "updateAluminiumTitle",
    updatePotlidLanguage: "updatePotlidLanguage",
    updatePotlidTitle: "updatePotlidTitle",
    updateContactUsTitle: "updateContactUsTitle",
    updateContactUsSubTitle: "updateContactUsSubTitle",
    updateContactUsAddress: "updateContactUsAddress",
    updateContactUsEmail: "updateContactUsEmail",
    updateContactUsPhone: "updateContactUsPhone",
    updateContactUsLanguage: "updateContactUsLanguage",
    updateMajorShoppingLanguage: "updateMajorShoppingLanguage",
    updateMajorShoppingTitle: "updateMajorShoppingTitle",
    updateMajorShoppingDescription: "updateMajorShoppingDescription",
    updateMajorShoppingSubTitle: "updateMajorShoppingSubTitle",
    updateMainBannerMajorShopping: "updateMainBannerMajorShopping",
    updateFaqDataTitle: "updateFaqDataTitle",
    updateFaqDataLanguage: "updateFaqDataLanguage",
    updateFaqDataDescription: "updateFaqDataDescription",
    updateOfferDataTitle: "updateOfferDataTitle",
    updateOfferDataLanguage: "updateOfferDataLanguage",
    updateOfferDataDescription: "updateOfferDataDescription",
    updateMainBannerHomePage: "updateMainBannerHomePage",
    updateMainBannerHomePageAboutUs: "updateMainBannerHomePageAboutUs",
    updateShopMainBanner: "updateShopMainBanner",
    updateHomePageAboutUsTitle: "updateHomePageAboutUsTitle",
    updateHomePageAboutUsSubTitle: "updateHomePageAboutUsSubTitle",
    updateHomePageAboutUsLanguage: "updateHomePageAboutUsLanguage",
    updateHomePageAboutUsDescription: "updateHomePageAboutUsDescription",
    updateHomePageStatueTitle: "updateHomePageStatueTitle",
    updateHomePageStatueLanguage: "updateHomePageStatueLanguage",
    updateHomePageStatueDescription: "updateHomePageStatueDescription",
    updateStatueImage: "updateStatueImage",
    updateCertificatesLanguage: "updateCertificatesLanguage",
    updateCertificatesTitle: "updateCertificatesTitle",
    updateCatalogLink: "updateCatalogLink",
    updateCertificatesText: "updateCertificatesText",
    updateCatalogText: "updateCatalogText",
    updateCatalogLanguage: "updateCatalogLanguage",
    updateLandingProductName: "updateLandingProductName",
    updateLandingProductSize: "updateLandingProductSize",
    updateLandingProductColor: "updateLandingProductColor",
    updateLandingProductCategory: "updateLandingProductCategory",
    updateLandingProductType: "updateLandingProductType",
    updateLandingProductAmount: "updateLandingProductAmount",
    updateLandingProductDescription: "updateLandingProductDescription",
    upadetCertificateImage: "upadetCertificateImage",
    upadetCatalogImage: "upadetCatalogImage",
    updateLandingProductImage: "updateLandingProductImage",
    updateCategoryPersianTitle: "updateCategoryPersianTitle",
    updateSubCategoryPersianTitle: "updateSubCategoryPersianTitle",
    updateSubCategoryArabicTitle: "updateSubCategoryArabicTitle",
    updateSubCategoryEnglishTitle: "updateSubCategoryEnglishTitle",
    updateLandingSubCategory: "updateLandingSubCategory",
    updateCategoryType: "updateCategoryType",
    updateCategoryEnglishTitle: "updateCategoryEnglishTitle",
    updateCategoryArabicTitle: "updateCategoryArabicTitle",
    updateCategoryDescription: "updateCategoryDescription",
    updateCategoryImage: "updateCategoryImage",
    updateCategoryImageEdit: "updateCategoryImageEdit",
    updateSelectedLandingProductName: "updateSelectedLandingProductName",
    updateSelectedLandingProductCategory:
      "updateSelectedLandingProductCategory",
    updateSelectedLandingProductImage: "updateSelectedLandingProductImage",
    updateSelectedLandingProductAmount: "updateSelectedLandingProductAmount",
    updateSelectedLandingProductType: "updateSelectedLandingProductType",
    updateSelectedLandingProductDescription:
      "updateSelectedLandingProductDescription",
    updateSelectedLandingProductDescriptionSizes:
      "updateSelectedLandingProductDescriptionSizes",
    updateSelectedLandingProductDescriptionColors:
      "updateSelectedLandingProductDescriptionColors",
    updateCategoryBanner: "updateCategoryBanner",
    updateBannerCategory: "updateBannerCategory",
    updateVideoPage: "updateVideoPage",
    updateVideoLink: "updateVideoLink",
    updateVideoDataTitle: "updateVideoDataTitle",
    updateVideoDataSubTitle: "updateVideoDataSubTitle",
    updateVideoDataDescription: "updateVideoDataDescription",
    // footer address
    updateFooterAddressLanguage: "updateFooterAddressLanguage",
    updateFooterAddressAddress: "updateFooterAddressAddress",
    updateFooterAddressPhone: "updateFooterAddressPhone",
    updateFooterAddressEmail: "updateFooterAddressEmail",
    // factory address
    updateFactoryAddressAddress: "updateFactoryAddressAddress",
    updateFactoryAddressLanguage: "updateFactoryAddressLanguage",
    // major shopping info
    updateMajorShoppingInfoLanguage: "updateMajorShoppingInfoLanguage",
    updateMajorShoppingInfoPhone: "updateMajorShoppingInfoPhone",
    updateMajorShoppingInfoEmail: "updateMajorShoppingInfoEmail",
    updateMajorShoppingInfoAddress: "updateMajorShoppingInfoAddress",
    // more box
    updateMoreBoxContentTitle: "updateMoreBoxContentTitle",
    updateMoreBoxContentDescription: "updateMoreBoxContentDescription",
    updateMoreBoxContentImage: "updateMoreBoxContentImage",
    // category
    updateCategoryTitle: "updateCategoryTitle",
    updateCategoryParent: "updateCategoryParent",
    updateCategoryParentPath: "updateCategoryParentPath",
    resetCategoryData: "resetCategoryData",
    // user
    setUsersList: "setUsersList",
    setUserProfile: "setUserProfile",
    setUserFullname: "setUserFullname",
    setUserAddress: "setUserAddress",
    setUserProvince: "setUserProvince",
    setUserCity: "setUserCity",
    setUserAvatar: "setUserAvatar",
    removeUserAvatar: "removeUserAvatar",
    setAmountWalletCharge: "setAmountWalletCharge",
    // admins
    setAdminsList: "setAdminsList",
    // invoices
    setInvoicesList: "setInvoicesList",
  },
};
